<div class="gray-bg-rounded">
  <div class="today-task">
    <p-accordion value="0">
      <p-accordion-panel value="0">
        <p-accordion-header>
          <div
            class="d-flex justify-content-between align align-items-top topboder col-8">
            <span
              class="d-flex justify-content-between gap-2 align-items-center">
              <span> <i class="pi pi-calendar-clock"></i></span>
              <h2 class="mb-0">
                Reminders <jni-spinner *ngIf="showSmallLoader"></jni-spinner>
              </h2>
            </span>
            <span
              ><a (click)="showDialog()" class="text-decoration-none blue-text"
                >Add New</a
              ></span
            >
          </div>
        </p-accordion-header>
        <p-accordion-content>
          <div class="reminder-box col-lg-12 mt-3">
            <div class="box-height">
              <div
                *ngIf="!showSmallLoader && reminders.length > 0; else noList">
                <div
                  *ngFor="let item of reminders"
                  class="col-lg-12 d-flex justify-content-between align-items-center today-list-bar mb-2 rounded p-2"
                  [ngStyle]="{
                    background: getBackgroundColor(
                      item.localReminderDate ?? ''
                    ),
                  }"
                  [ngClass]="{
                    'reminder-text-new':
                      getBackgroundColor(item.localReminderDate ?? '') !==
                      '#dd4040',
                  }">
                  <div>
                    <h3 class="mb-0">{{ item.title }}</h3>
                    <p class="mb-0">
                      <small>{{
                        item.localReminderDate | date: "medium"
                      }}</small>
                    </p>
                  </div>
                  <div class="col-auto d-flex align-items-center">
                    <span
                      class="text-white"
                      *ngIf="
                        getBackgroundColor(item.localReminderDate ?? '') ===
                        '#dd4040'
                      "
                      ><i class="pi pi-exclamation-circle"></i
                    ></span>
                    <span class="ms-2"></span>
                    <a
                      class="position-relative text-white"
                      href="javascript:;"
                      *ngIf="item && item.id"
                      (click)="deleteReminder(item.id)"
                      ><i class="pi pi-trash"></i
                    ></a>
                  </div>
                </div>
              </div>

              <ng-template #noList>
                <div class="col-lg-12 today-list-bar gray-bg">
                  <div
                    class="lds-ring inline me-auto ms-2"
                    *ngIf="showSmallLoader">
                    <div></div>
                    <div></div>
                    <div></div>
                  </div>
                  <h3 *ngIf="!showSmallLoader">No list available.</h3>
                </div>
              </ng-template>
            </div>
          </div>
        </p-accordion-content>
      </p-accordion-panel>
    </p-accordion>
  </div>
</div>
<p-dialog
  header="Add Reminder"
  [(visible)]="display"
  [style]="{ width: '25%', height: '33%', maxHeight: '100%' }"
  appendTo="body">
  <div [formGroup]="reminderForm" class="col-lg-12">
    <div class="col-12 mb-4">
      <div class="form-group has-float-label">
        <input
          jniAutoCompleteBlocker
          name="pName"
          type="text"
          class="form-control"
          id="pName"
          formControlName="title" />
        <label class="form-label" for="Caccount"
          >Subject<span class="madatory-field">*</span></label
        >
      </div>
    </div>

    <div class="col-12 mb-4">
      <div class="form-group has-float-label mb-4">
        <p-datePicker
          jniAutoCompleteBlocker
          [inputStyle]="{ height: '30px' }"
          [style]="{ width: '100%' }"
          [showButtonBar]="false"
          appendTo="body"
          [showIcon]="true"
          formControlName="reminderDate"
          [showTime]="true"
          [stepMinute]="1"
          [minDate]="dateMin"
          [hourFormat]="'12'">
        </p-datePicker>
        <label class="form-label">Due Date</label>
      </div>
    </div>

    <div class="col-lg-12 mt-3 d-flex gap-3 justify-content-end">
      <button
        pButton
        type="button"
        label="Cancel"
        class="p-button-secondary p-button-sm p-button-outlined"
        (click)="closeDialog()"></button>
      <button
        pButton
        type="button"
        label="Create Reminder"
        class="p-button-sm"
        (click)="createReminders()"></button>
    </div>
  </div>
</p-dialog>

<jni-confirm-dialog
  [dialogMessage]="dialogMessage"
  dialogHeading="Delete Confirmation"
  *ngIf="deleteReminderVisible"
  (confirmDialogStatus)="deleteReminderById($event)">
</jni-confirm-dialog>
